export default "__VITE_ASSET__5c496735__"